(function webpackUniversalModuleDefinition(root, factory) {
	//React Hoc Modal
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	//React Hoc Modal
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	//React Hoc Modal
	else if(typeof exports === 'object')
		exports["Modal"] = factory(require("react"), require("react-dom"));
	//React Hoc Modal
	else
		root["Modal"] = factory(root["react"], root["react-dom"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__317__, __WEBPACK_EXTERNAL_MODULE__730__) => {
return 